/* eslint-disable no-undef */
const isLocal = window.location.hostname === "localhost";

const environments = {
  development: {
    API_URL: "https://api.dev.bigfootmail.com/api/v1/",
    MAIL_URL: "https://mail.dev.bigfootmail.com/",
    DRIVE_URL: "https://drive.dev.bigfootmail.com/",
    CHAT_URL: "https://chat.dev.bigfootmail.com/",
    ACCOUNT_URL: "https://account.dev.bigfootmail.com/",
    SOCKET_URL: "https://api.dev.bigfootmail.com",
  },
  production: {
    API_URL: "https://api.dev.bigfootmail.com/api/v1/",
    MAIL_URL: "https://mail.dev.bigfootmail.com/",
    DRIVE_URL: "https://drive.dev.bigfootmail.com/",
    CHAT_URL: "https://chat.dev.bigfootmail.com/",
    ACCOUNT_URL: "https://account.dev.bigfootmail.com/",
    SOCKET_URL: "https://api.dev.bigfootmail.com",
  },
};

const localOverrides = {
  MAIL_URL: "https://mail.dev.bigfootmail.com/",
  CHAT_URL: "https://chat.dev.bigfootmail.com/",
  DRIVE_URL: "http://localhost:3000/",
  ACCOUNT_URL: "http://localhost:3001/",
};

console.log(process.env.NODE_ENV, "process.env.NODE_ENV");

const env =
  process.env.NODE_ENV === "production" ? "production" : "development";

export const urls = {
  ...environments[env],
  ...(isLocal ? localOverrides : {}),
};
